import { defineComponent, onMounted, onBeforeUnmount, ref, watch, computed } from 'vue';

export default defineComponent({
  name: 'writepane',
  props: {
    active_dialog: String,
    new_contact_id: String,
    new_phone_number: String
  },
  template: '#writepane-template',
  setup(props, { emit }) {
    const messageTextInput = ref(null);
    const messageImprint = ref(null);

    // Computed property to access new_contact_id reactively
    const newContactId = computed(() => props.new_contact_id);
    
    // Watch for changes in new_contact_id
    watch(newContactId, (newId) => {
      console.log('New Contact ID:', newId); // Log the new contact ID
    }, { immediate: true });

    // ── OVER-LIMIT NOTICE ────────────────────────────────────────────────────────────────────────
    // Carriers reject a single SMS body over 1600 characters (Twilio 21617). TwilioSender now splits
    // automatically, but the dealer should be told BEFORE they send that their message will arrive
    // as more than one text — especially for anything formal.
    //
    // This is the visible half of the 2026-08-28 fix: Alejandro Cars #2860 sent the same
    // 1,705-character collection notice to three contacts, every one was rejected, and nothing on
    // screen said so. He believed three legal notices had been served.
    const SMS_MAX_BODY = 1600;
    const SMS_PART_PREFIX_ROOM = 12;

    const smsPartCount = (len) =>
      len <= SMS_MAX_BODY ? 1 : Math.ceil(len / (SMS_MAX_BODY - SMS_PART_PREFIX_ROOM));

    const updateLengthNotice = () => {
      const input = document.getElementById('message_text_input');
      const notice = document.getElementById('sms_length_notice');
      if (!input || !notice) return;

      const len = (input.value || '').length;
      if (len <= SMS_MAX_BODY) {
        notice.style.display = 'none';
        return;
      }
      const parts = smsPartCount(len);
      notice.textContent =
        len.toLocaleString() + ' characters — over the ' + SMS_MAX_BODY.toLocaleString() +
        ' limit for one text. It will be sent as ' + parts + ' messages, split at a sentence break, ' +
        'with your wording unchanged.';
      notice.style.display = 'block';
    };

    onMounted(() => {
      const input = document.getElementById('message_text_input');
      if (input) input.addEventListener('input', updateLengthNotice);
    });

    onBeforeUnmount(() => {
      const input = document.getElementById('message_text_input');
      if (input) input.removeEventListener('input', updateLengthNotice);
    });

    const sendButtonClicked = () => {
      if ($('#message_text_input')[0].value == '') {
        return false;
      }
      else {
        messageFormSubmit(); // Call submit method directly
      }
    };

    const showSendError = (text) => {
      const notice = document.getElementById('message_send_error');
      if (!notice) return;
      notice.textContent = text || '';
      notice.style.display = text ? 'block' : 'none';
    };

    const random_id = () => {
      return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10);
    };

    const messageFormSubmit = async (event) => {
      const text = $('#message_text_input')[0].value;
      const imprint = random_id();
      messageImprint.value = imprint;

      const newContactId = document.querySelector('input[name="new_contact_id"]').value;
      const newPhoneNumber = document.querySelector('input[name="new_phone_number"]').value;

      // Ensure the message text is not empty
      if (!text) {
        console.log('Message input is empty, not submitting.');
        return;
      }

      const dialogId = document.getElementById('message_dialog_id').value;
      if (dialogId === '-1' && !newPhoneNumber && (!newContactId || newContactId === '0')) {
        showSendError('Choose a contact or enter a phone number to send this message to.');
        return;
      }
      showSendError(null);

      // Prepare the data for submission
      const data = {
        message: {
          dialog_id: dialogId, // Get dialog_id from hidden input
          imprint: imprint,
          text: text
        },
        new_contact_id: newContactId, // Add new_contact_id to params
        new_phone_number: newPhoneNumber // Add new_phone_number to params
      };

      console.log('Submitting:', data);

      // AJAX submission
      try {
        const response = await fetch('/messages', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
          },
          body: JSON.stringify(data) // Send the prepared data
        });

        if (!response.ok) {
          // Keep the dealer's text in the composer and say why it didn't go.
          let reason = null;
          try { reason = (await response.json()).error; } catch (e) { /* not JSON */ }
          showSendError(reason || 'Your message was not sent. Please try again.');
          return;
        }

        // Clear the composer and append the sent message in-place (no full-page reload). The same
        // handler also receives Faye pushes, so the message appears once (deduped by id).
        $('#message_text_input')[0].value = '';
        try {
          const result = await response.json();
          if (window.vm_messaging && result && result.message) {
            window.vm_messaging.messageReceived(result);
          }
        } catch (e) {
          // No JSON body — Faye will deliver the message.
        }
      } catch (error) {
        console.error('Error:', error);
        showSendError('Your message was not sent. Check your connection and try again.');
      }
    };

    const messageFormBeforeSend = () => {
      messageTextInput.value.value = '';
    };

    onMounted(() => {
      const form = document.getElementById('message_form');
      if (form) {
        form.addEventListener('ajax:before', (event) => {
          console.log('Ajax before event triggered');
          messageFormSubmit(event);
        });
        form.addEventListener('ajax:beforeSend', () => {
          console.log('Ajax before send event triggered');
          messageFormBeforeSend();
        });
      }
    });


    onBeforeUnmount(() => {
      const form = document.getElementById('message_form');
      if (form) {
        form.removeEventListener('ajax:before', messageFormSubmit);
        form.removeEventListener('ajax:beforeSend', messageFormBeforeSend);
      }
    });

    // Return everything that needs to be accessed in the template
    return {
      messageTextInput,
      messageImprint,
      newContactId,
      sendButtonClicked // Make sure this method is returned so it can be used in the template
    };
  }
});
